module.exports = __webpack_public_path__ + "img/truck-cover.2ed2605e.png";